import { Injectable } from '@angular/core';
import { SymbolType } from '../../../../../domain/symbol.domain';
import { TradingAccount } from '../../../../../domain/account.domain';
import { NumberService } from '../../../../../services/number/number.service';
import {
  MutualFundDividendType,
  MutualFundOrderAction,
  MutualFundQuantityType
} from '../../../domain';
import { MutualFundFormModel, OrderFormParameters, OrderStateParameters } from '../../domain/order-entry.domain';
import { CreateOrderFormService } from './create-order-form.service';

@Injectable()
export class CreateOrderMutualfundFormService extends CreateOrderFormService<MutualFundFormModel> {

  initializeViewModel(_selectedAccount?: TradingAccount, orderFormParameters?: OrderFormParameters): MutualFundFormModel {

    this.temp = {
      selectedSymbol: undefined,
      orderAction: MutualFundOrderAction.BUY,
      orderQuantityType: undefined,
      quantityTypeAmount: undefined,
      quantityTypeUnits: undefined,
      dividendOption: MutualFundDividendType.REINVEST,
      includeCommissionIndicator: true
    };

    // in case there are parameters, adjust the model
    if (orderFormParameters !== undefined && orderFormParameters.orderStateParameters !== undefined) {
      const parameters = Object.assign({}, orderFormParameters.orderStateParameters);
      if (parameters.symbol !== undefined && parameters.market !== undefined) {
        this.setOrderSymbol({
          symbol: parameters.symbol,
          market: parameters.market
        });
      }
      if (parameters.action !== undefined) {
        this.setOrderFormAction({
          action: parameters.action,
          quantity: parameters.quantity
        });
      }
    }

    return Object.assign({}, this.temp);
  }

  private resetDividendTypeByAction(): void {
    this.temp.dividendOption = MutualFundDividendType.NA;
    this.temp.includeCommissionIndicator = true;
    if (this.temp.orderAction === MutualFundOrderAction.BUY ||
      this.temp.orderAction === MutualFundOrderAction.SWITCH) {
      this.temp.dividendOption = MutualFundDividendType.REINVEST;
    }
  }

  private setOrderFormAction(parameters: Pick<OrderStateParameters, 'action' | 'quantity'>): void {
    this.temp.orderAction = MutualFundOrderAction.BUY;
    if (parameters.action === 'sell') {
      this.temp.orderAction = MutualFundOrderAction.SELL;
      this.setOrderQuantityTypeForSell(parameters);
      this.resetDividendTypeByAction();
    }
  }

  private setOrderQuantityTypeForSell(parameters: Pick<OrderStateParameters, 'action' | 'quantity'>): void {
    if (parameters.quantity !== undefined && NumberService.isNumber(parameters.quantity)) {
      this.temp.orderQuantityType = MutualFundQuantityType.FULL_BALANCE;
    } else {
      this.temp.orderQuantityType = MutualFundQuantityType.UNITS;
      this.temp.quantityTypeUnits = parameters.quantity; // TODO:  parse properly
    }
  }

  private setOrderSymbol(parameters: Pick<OrderStateParameters, 'symbol' | 'market'>): void {
    if (parameters.symbol !== undefined) {
      this.temp.selectedSymbol = {
        symbol: parameters.symbol,
        market: parameters.market,
        type: SymbolType.MUTUALFUND,
        symbolType: SymbolType.MUTUALFUND
      };
    }
  }
}

